import * as types from 'src/store/mutation-types'

import { ActivitiesClient } from 'src/api/Activities'

// initial state
// shape: [{ id, quantity }]
const state = {
  activities: [],
  activitiesMeta: null,
  activitiesLoaded: false
}

// getters
const getters = {
  activities: state => state.activities,
  activitiesMeta: state => state.activitiesMeta,
  activitiesLoaded: state => state.activitiesLoaded
}

const paginationDefault = {
  page: 1,
  rowsNumber: 0,
  rowsPerPage: 8,
  descending: true,
  sortBy: 'created_at'
}

const actions = {
  listActivities ({ commit, state }, { pagination } = {}) {
    pagination = { ...paginationDefault, ...(pagination || {}) }

    const sort = [pagination.sortBy, pagination.descending ? 'desc' : 'asc']
    commit(types.SET_ACTIVITIES_LOADED, false)

    return new ActivitiesClient()
      .sort(sort)
      .page(pagination.page)
      .limit(pagination.rowsPerPage)
      .include(['user', 'subject', 'subject.customer', 'subject.supplier'])
      .list()
      .then(response => {
        commit(types.SET_ACTIVITIES, response.data.data)
        commit(types.SET_ACTIVITIES_META, response.data.meta)
        commit(types.SET_ACTIVITIES_LOADED, true)
      })
      .then(() => Promise.resolve({ activities: state.activites, meta: state.activitiesMeta }))
  }
}

// mutations
const mutations = {
  [types.SET_ACTIVITIES] (state, activities) {
    state.activities = activities
  },

  [types.SET_ACTIVITIES_META] (state, meta) {
    state.activitiesMeta = meta
  },

  [types.SET_ACTIVITIES_LOADED] (state, value) {
    state.activitiesLoaded = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
